module.exports = __webpack_public_path__ + "df8e74534a5dad8cd66d839de60681fb.svg";